module.exports = __webpack_public_path__ + "static/media/DevLab.ec1421e1.md";